import { PlaceAddressComponents, PlaceDetails, StoreClientAddressData } from '../types';

interface MappedComponents {
  street?: string | null;
  country?: string | null;
  zipcode?: string | null;
  number?: string | null;
  neighborhood?: string | null;
  city?: string | null;
  state?: string | null;
  complement?: string | null;
}

interface TypeMapping {
  key: keyof MappedComponents;
  value: 'shortName' | 'longName';
  transform?: (value: string | null) => string | null;
}

const mapPlaceComponents = (components: PlaceAddressComponents[]): MappedComponents => {
  const typeMap: Record<string, TypeMapping> = {
    route: { key: 'street', value: 'shortName' },
    country: { key: 'country', value: 'shortName', transform: (v) => (v ? v.toUpperCase() : null) },
    postal_code: { key: 'zipcode', value: 'longName' },
    street_number: { key: 'number', value: 'longName' },
    sublocality_level_1: { key: 'neighborhood', value: 'longName' },
    administrative_area_level_2: { key: 'city', value: 'longName' },
    administrative_area_level_1: { key: 'state', value: 'shortName' },
    complement: { key: 'complement', value: 'longName' },
  };

  return components.reduce((acc: MappedComponents, component) => {
    const type = component.types[0];
    if (!type) return acc;

    const mapping = typeMap[type];
    if (!mapping) return acc;

    const rawValue = (component as any)[mapping.value] || null;
    const value = mapping.transform ? mapping.transform(rawValue) : rawValue;

    return { [mapping.key]: value, ...acc };
  }, {});
};

export const mapPlaceToAddressData = (place: PlaceDetails): StoreClientAddressData => {
  const data = mapPlaceComponents(place.addressComponents);

  return {
    number: data.number ?? null,
    zipcode: data.zipcode ?? null,
    country: data.country ?? null,
    street: data.street ?? null,
    complement: data.complement ?? null,
    city: data.city ?? null,
    state: data.state ?? null,
    neighborhood: data.neighborhood ?? null,
    is_default: false,
    reference: null,
  };
};
